import { call, put, takeEvery } from 'redux-saga/effects';
import { newDealerActionCreators, NewDealerActionKeys, SearchNewDealerCatalog } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { IProduct, productsActionCreators } from '../../products';
import { showFailedRequestDialog } from '../../sagaUtils';
import * as api from '../newDealerApi';

function* searchNewDealerCatalogSaga(action: SearchNewDealerCatalog) {
  yield put(newDealerActionCreators.toggleCatalogSearch());
  const response: IApiExecuteRespone<IProduct[]> = yield call(api.searchNewDealerCatalog, action.payload);

  if (!response.requestFailed && response.value) {
    yield put(newDealerActionCreators.setSearch({ ...action.payload, products: response.value }));
    yield put(productsActionCreators.setProducts(response.value));
  } else {
    yield showFailedRequestDialog(response);
  }

  yield put(newDealerActionCreators.toggleCatalogSearch());
}

export function* watchSearchNewDealerCatalog() {
  yield takeEvery(NewDealerActionKeys.SEARCH_NEW_DEALER_CATALOG, searchNewDealerCatalogSaga);
}
